<template>
  <export-excel
    class="export_btn"
    :fields="custom_fields"
    :fetch="getData"
    type="csv"
    :footer="[
      `Township : ${townshipName}`,
      `Month:${$route.query.month}/Year:${$route.query.year}`,
    ]"
    :name="`Monthly Report for ${$route.query.month}/${$route.query.year}.xls`"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>Export
  </export-excel>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["datas", "townshipName"],
  computed: {
    ...mapState("Admin", ["admin"]),
  },
  data: () => ({
    custom_fields: {
      "Sr.No": {
        field: "counter",
        callback: (value) => {
          return value;
        },
      },
      Indicators: "title",
      Male: {
        field: "data",
        callback: (value) => {
          return value.male != null ? value.male : "";
        },
      },
      Female: {
        field: "data",
        callback: (value) => {
          return value.female != null ? value.female : "";
        },
      },
      Total: {
        field: "data",
        callback: (value) => {
          return value.male != null && value.female != null
            ? parseInt(value.male) + parseInt(value.female)
            : value;
        },
      },
    },
  }),

  methods: {
    getData() {
      if (this.datas) return this.datas;
    },
  },
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 120px;
  padding: 5px 15px;
  margin-bottom: 1px;
}
</style>   